export { CfsPage as default } from '@/components/enpages/Ir/Financial/Cfs'
